export default "__VITE_ASSET__BkZMu9hq__"